import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useFloatingAlert } from '@99designs/emu';
import { breakpoints, spaces } from '@99designs/emu/settings';
import { IconX1 } from '@99designs/icons';
import { FullscreenOverlay } from '@99designs/spa-common';
import { FullscreenFrame } from '@99designs/spa-common';
import { FullscreenFrameMain } from '@99designs/spa-common';
import { FullscreenFrameSidebar } from '@99designs/spa-common';
import { FullscreenMain } from '@99designs/spa-common';
import { FullscreenMainBody } from '@99designs/spa-common';
import { OnWhiteIconButton } from '@99designs/spa-common';
import SkeletonBlock, { pulseKeyframes } from './SkeletonBlock';

const FileOverlaySkeletonBody = styled.div`
    height: 90%;
    width: 90%;
    margin: 5% auto 0px;
    animation: ${pulseKeyframes} 1s infinite 0.2s;

    @media (min-width: ${breakpoints.small[0]}px) and (max-width: ${breakpoints.small[1]}px),
        (min-width: ${breakpoints.medium[0]}px) {
        height: 65vh;
        margin: ${spaces['3bu']} 5% ${spaces['1.5bu']};
    }
`;

const FileOverlaySkeletonHeaderSection = styled.div`
    padding: ${spaces['1bu']};

    @media (min-width: ${breakpoints.normal[0]}px) and (max-width: ${breakpoints.normal[1]}px),
        (min-width: ${breakpoints.large[0]}px) {
        padding: ${spaces['1bu']} ${spaces['2bu']} ${spaces['1.5bu']};
    }
`;
const FileOverlaySkeletonCloseButton = styled.div`
    position: absolute;
    z-index: 3;
    top: ${spaces['1bu']};
    right: ${spaces['2bu']};

    @media (min-width: ${breakpoints.small[0]}px) and (max-width: ${breakpoints.small[1]}px),
        (min-width: ${breakpoints.medium[0]}px) {
        right: ${spaces['1.5bu']};
    }
`;

export interface FileOverlaySkeletonProps {
    goBack: () => void;
    errorMessage?: string;
}
function FileOverlaySkeleton({ goBack, errorMessage }: FileOverlaySkeletonProps) {
    const floatingAlert = useFloatingAlert();
    useEffect(() => {
        if (errorMessage) {
            floatingAlert({ message: errorMessage, type: 'error' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMessage]);

    return (
        <FullscreenOverlay isActive isScrollableSmallScreens hasAdminBarOffset={false}>
            <FileOverlaySkeletonCloseButton data-testid="close-overlay-button">
                <OnWhiteIconButton aria-label="Close" onClick={goBack}>
                    <IconX1 />
                </OnWhiteIconButton>
            </FileOverlaySkeletonCloseButton>
            <FullscreenFrame>
                <FullscreenFrameMain>
                    <FullscreenMain>
                        <FullscreenMainBody>
                            <FileOverlaySkeletonBody />
                        </FullscreenMainBody>
                    </FullscreenMain>
                </FullscreenFrameMain>
                <FullscreenFrameSidebar>
                    <FileOverlaySkeletonHeaderSection>
                        <SkeletonBlock headingLevel={4} width="80px" />
                        <SkeletonBlock headingLevel={5} width="100px" />
                        <SkeletonBlock width="190px" />
                        <SkeletonBlock width="190px" />
                        <SkeletonBlock inline width="80px" />
                        <SkeletonBlock inline />
                    </FileOverlaySkeletonHeaderSection>
                    <FileOverlaySkeletonHeaderSection>
                        <SkeletonBlock headingLevel={4} width="160px" />
                        <SkeletonBlock headingLevel={4} width="160px" />
                    </FileOverlaySkeletonHeaderSection>
                </FullscreenFrameSidebar>
            </FullscreenFrame>
        </FullscreenOverlay>
    );
}

export default FileOverlaySkeleton;
